import { useModel, useRequest } from 'umi';
import React, { memo, useEffect, useState } from 'react';
import styles from '../css/dynamicCSS.less';
import { getReplyPage, postDynamicReply } from '@/utils/requests/camp/requests_dynamic';
import { DynamicType } from '@/types/camp/dynamic/dynamicType';
import DynamicReplyItem from './dynamicReplyItem';
import DynamicDetailsItem from './dynamicDetailsItem';
import { InfiniteScroll } from 'antd-mobile';
import { Avatar, message } from 'antd';
import cx from 'classnames';
import { Modal } from '@digit-fe/digit-component';
import CommentForm from './commentForm';

interface props {
  item: DynamicType;
  open: boolean;
  setOpen: (open: boolean) => void;
  setHash: (hash: number) => void;
}
interface PostType {
  dynamicId: string;
  content: string;
  image?: string;
}
const DynamicDetails: React.FC<props> = ({ item, open, setOpen, setHash }) => {
  const [dataList, setDataList] = React.useState<DynamicType[]>([]);
  const [current, setCurrent] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const { initialState } = useModel('@@initialState');
  const [oneLoad, setOneLoad] = useState<boolean>(false);

  // 发布评论
  const postDynamicReplyRequest = useRequest(
    (submitValue: PostType) => {
      return postDynamicReply(submitValue);
    },
    {
      manual: true,
      onSuccess: (res) => {
        message.success('操作成功');
        // 刷新回复列表
        getPageRun(true);
        item.commentsCount = res.dynamicCommentsCount;
      },
      onError: (e) => {},
    },
  );

  // 获取接口
  const { run: getReplyPageRequest } = useRequest(
    () => {
      return getReplyPage({
        dynamicId: item.id || '',
        current: 1,
        size: 10,
      });
    },
    {
      manual: true,
      onSuccess: (res) => {
        setDataList([...res.data.records]);
      },
    },
  );

  // 获取动态分页
  const getPageRun = (newRun: boolean = false) =>
    getReplyPage({
      dynamicId: item.id || '',
      current: newRun ? 1 : current,
      size: 10,
    })
      .then((res: any) => {
        setTotal(res.data.total);
        setOneLoad(true);
        if (dataList && !newRun) {
          setDataList([...dataList, ...res.data.records]);
        } else {
          setDataList([...res.data.records]);
        }
        setCurrent(current + 1);
        setTotal(res.data.total);
        setHasMore(res.data.current < res.data.pages);
      })
      .finally(() => {
        setLoading(false);
      });

  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean }) => {
    return (
      <>
        {hasMore ? (
          <>
            <div></div>
          </>
        ) : total > 0 ? (
          <span>—— 没有更多了 ——</span>
        ) : (
          ''
        )}
      </>
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!oneLoad) {
        getReplyPageRequest();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [oneLoad]);

  return (
    <div className={styles.dynamic_details}>
      <Modal
        title={'动态详情'}
        wrapClassName={cx(styles.modal_dynamic_details, styles.modal_dynamic_details_visible)}
        open={open}
        // style={{ height: '90vh' }}
        destroyOnClose={true}
        forceRender={true}
        centered
        width={1200}
        onOk={() => {}}
        onCancel={() => {
          setOpen(false);
        }}
        footer={null}
      >
        <div style={{ paddingRight: 10 }}>
          <div>
            <DynamicDetailsItem item={item} />
          </div>

          <div className={cx(styles.dynamic_details_post_msg, 'flex_0')}>
            <div style={{ width: 60 }}>
              <a href={`https://bbs.fanruan.com/u/${initialState?.uid}`} target="_blank">
                <Avatar
                  size={48}
                  src={`https://bbs.fanruan.com/uc_server/avatar.php?uid=${initialState?.uid}&amp;size=small`}
                />
              </a>
            </div>
            <div style={{ flex: 1 }}>
              <CommentForm
                key={item.id}
                onSubmit={(values) => {
                  const submitValue: PostType = {
                    dynamicId: item.id,
                    content: values.content,
                    image: values.imageUrl,
                  };
                  submitValue && postDynamicReplyRequest.run(submitValue);
                }}
              />
            </div>
          </div>
          <div className="f20 fw600" style={{ margin: '14px 0 0 0' }}>
            全部评论 {item.commentsCount}
          </div>
          <div className={styles.dynamic_details_box}>
            {dataList &&
              dataList?.map((item, index) => (
                <DynamicReplyItem key={index} item={item} index={index} />
              ))}
          </div>
          <InfiniteScroll loadMore={getPageRun} hasMore={hasMore}>
            <InfiniteScrollContent hasMore={hasMore} />
          </InfiniteScroll>
        </div>
      </Modal>
    </div>
  );
};
export default memo(DynamicDetails);
